import{SeverityValue as e}from"../../interfaces/DiagnosticReport.js";const f={[e.Low]:"#04af65",[e.Mild]:"#ffa500",[e.Severe]:"#ff0100"};function o(e){return e.map((e=>f[e.value]))}export{o as createColorsArray,f as severityColor};
